import React, { useEffect, useState } from 'react';
import "./Contact.scss";
import {send, init} from "@emailjs/browser";

const Contact = () => {
  const [heightOver, setHeightOver] = useState(false);
  const [heightOver2, setHeightOver2] = useState(false);
  const [heightOver3, setHeightOver3] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const scrollAction = () => {
      if (2700 < window.scrollY) {
        setHeightOver(true);
      }
    };
    const scrollAction2 = () => {
      if (2700 < window.scrollY) {
        setHeightOver2(true);
      }
    };
    window.addEventListener("scroll", scrollAction, {
      capture: false,
      passive: true,
    });
    window.addEventListener("scroll", scrollAction2, {
      capture: false,
      passive: true,
    });
    scrollAction();
    scrollAction2();
    return () => {
      window.removeEventListener("scroll", scrollAction);
      window.removeEventListener("scroll", scrollAction2);
    };
  }, []);
  // const sendEmail = async (e) => {
  //   e.preventDefault();

  //   const userID = process.env.REACT_APP_USER_ID;
  //   const serviceID = process.env.REACT_APP_SERVICE_ID;
  //   const templateID = process.env.REACT_APP_TEMPLATE_ID;

  //     if(userID && serviceID && templateID ) {
  //       init("user_U04Egw8sAtta6iIXuUp4X");
        
  //       const template_param = {
  //         to_name: "岡村隼斗",
  //         from_name: name,
  //         phone: phone,
  //         email: email,
  //         message: message,
  //       };

  //       try{
  //         await  send(serviceID, templateID, template_param);
  //       } catch(e) {
  //         window.alert(e.message)
  //       }
  //     }
  // }
  return (
    <div className="contact-container">
    <div className="contact-background"></div>
       <div className="title-box">
        <h2 className={heightOver ? "title-h2" : "scroll"}>Contact</h2>
        <p className={heightOver ? "title-p" : "scroll"}>お問い合わせ</p>
        <span className={heightOver ? "title-triangle" : "scroll"}></span>
        <span className={heightOver ? "title-triangle2" : "scroll"}></span>

      </div>
      <div className={heightOver2 ? "user-info-container" : "scroll"}>

        <div className="user-info-wrapper">
        <div className="user-info-box">
        <i className="fas fa-phone"></i>
        <ul>
          <li>Phone</li>
          <li>080-9563-4470</li>
        </ul>
        </div>
        <div className="user-info-box">
        <i class="fas fa-envelope"></i>
        <ul>
          <li>Email</li>
          <li>keepsmile.lucky7@gmail.com</li>
        </ul>
        </div>
        <div className="user-info-box">
        <i class="fas fa-map-marker-alt"></i>
        <ul>
          <li>Address</li>
          <li><span>埼玉県</span><span>朝霞市</span><span>根岸台</span>2-2-15</li>
        </ul>
        </div>
        </div>

        <div className="contact-wrapper">
          <h3><span>Send</span><span>Message</span></h3>
          <form>
            <div className="input-wrapper">
            <input className="input" type="text"  placeholder="Name" >
            </input>
            <input className="input" type="email" placeholder="Email"></input>
            <textarea className="input" type="text" rows="3" placeholder="Type&nbsp;your&nbsp;message..."></textarea>
            </div>
            <span className="focus-line"></span>

            <button>send</button>
          </form>
        </div>

      </div>
      </div>
  )
}

export default Contact;